// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:1366px){.app-main[data-v-3cfd6572]{padding-top:81px}}@media(max-width:1365px){.app-main[data-v-3cfd6572]{padding-top:65px}}", ""]);
// Exports
module.exports = exports;
